export default __webpack_public_path__ + "static/media/kaiser.b8988b11.png";